import { useTranslation } from "react-i18next";
import { ResourceTypeLink } from "@evergis/api";

import { useDialogInfo } from "../../../../hooks/useDialogs";

export const useTitleText = (type?: ResourceTypeLink): string => {
  const { i18n } = useTranslation("dialogs");
  const { resources: resourceNamesToDelete } = useDialogInfo(true);
  const plural = resourceNamesToDelete.length > 1;

  if (i18n.language === "en") {
    switch (type) {
      case ResourceTypeLink.Project:
        return `Deletion of ${plural ? "maps" : "map"}`;
      case ResourceTypeLink.Layer:
        return `Deletion of ${plural ? "layers" : "layer"}`;
      case ResourceTypeLink.Table:
        return `Deletion of ${plural ? "tables" : "table"}`;
      default:
        return null;
    }
  } else {
    switch (type) {
      case ResourceTypeLink.Project:
        return `Удаление ${plural ? "карт" : "карты"}`;
      case ResourceTypeLink.Layer:
        return `Удаление ${plural ? "слоёв" : "слоя"}`;
      case ResourceTypeLink.Table:
        return `Удаление ${plural ? "источников данных" : "источника данных"}`;
      default:
        return null;
    }
  }
};
